export var Api_Video_Type;
(function (Api_Video_Type) {
    Api_Video_Type["COLLAB_MIRROR"] = "collab_mirror";
    Api_Video_Type["COLLAB_REACT"] = "collab_react";
    Api_Video_Type["COLLAB_SPLIT"] = "collab_split";
    Api_Video_Type["COLLAB_STITCH"] = "collab_stitch";
    Api_Video_Type["FRAMELESS"] = "frameless";
    Api_Video_Type["LIVESTREAM"] = "live_stream";
    Api_Video_Type["MULTICAM"] = "multicam";
    Api_Video_Type["OPEN_AUCTION_AD"] = "open_auction_ad";
})(Api_Video_Type || (Api_Video_Type = {}));
